<template>
  <a-form-model ref="form" :model="formdata" :rules="rules" v-bind="layout">
    <a-form-model-item label="手机号" prop="phone">
      <a-input v-model="formdata.phone" type="text" autocomplete="off">
        <span
          style="cursor: pointer;"
          slot="addonAfter"
          @click.stop="onGetCode"
        >{{time>0?`${time}s后重新获取`:'获取验证码'}}</span>
      </a-input>
    </a-form-model-item>
    <a-form-model-item label="验证码" prop="code">
      <a-input v-model="formdata.code" type="text" autocomplete="off" />
    </a-form-model-item>
    <a-form-model-item label="新密码" prop="pwd">
      <a-input-password v-model="formdata.pwd" autocomplete="off" />
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
      <a-button type="primary" @click="onSubmit" block>重置密码</a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      time: 0,
      formdata: {
        phone: "",
        code: "",
        pwd: "",
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入正确的手机号",
            pattern: /^1[2-9]\d{9}$/,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入正确的验证码",
            pattern: /^\d{4}$/,
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            message: "请输入至少输入6位",
            trigger: "blur",
          },
        ],
      },
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      },
    };
  },
  methods: {
    ...mapActions("user", ["getCode", "reset", "toggleModal"]),
    onGetCode() {
      if (this.time > 0) {
        return;
      }
      this.$refs.form.validateField(["phone"], async (error) => {
        if (!error) {
          const response = await this.getCode({ phone: this.formdata.phone });
          if (response && response.code == 200) {
            this.time = 60;
            let timer = setInterval(() => {
              if (--this.time < 1) {
                this.time = 0;
                clearInterval(timer);
              }
            }, 1000);
          }
          console.info("response", response);
        }
      });
    },
    onSubmit(formName) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const response = await this.reset(this.formdata);
          console.info("reset", response);
          if (response && response.code == 200) {
            this.$message.success("操作成功");
            this.toggleModal({ type: "login", visible: true });
          }
        }
      });
    },
  },
};
</script>
